import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Consegna',
  [ORDER_METHODS.pickup]: 'Ritiro',
  [ORDER_METHODS.on_site]: 'Ordini al tavolo',
};
